import React from 'react'
import {Icon} from '@chakra-ui/react'

const CompareIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 22.0003H8V20.0003H6V24.0003H10V22.0003ZM18 0V18H0V0H18ZM2 2V16H16V2H2ZM22 8.0003H20V6.0003H24V10.0003H22V8.0003ZM22 20.0003V22.0003H20V24.0003H24V20.0003H22Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CompareIcon
